import { useRef, useState } from "react"
import { SectionHeading, TableCustom, WrapperAdvancedSearch } from "../../components/common"
import { useManagedContext } from "../../components/hooks"
import { usePermissions } from "../../components/hooks/usePermissions"
import { APIS } from "../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../utils/requests"
import { ServerRequest } from "../../utils/apiweb"
import { REQUEST_METHOD } from '@laramie/ui';
import { PERMISSIONS } from "../../consts/permissions"
import EscribanoModal from "../../components/controls/EscribanoModal"

const EscribanosView = () => {
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [data, setData] = useState([])
    const [editMode, setEditMode] = useState(null)
    const [editItem, setEditItem] = useState(null)
    const [tableVisible, setTableVisible] = useState(false)
    
    const searchRef = useRef()

    const { hasPermission } = usePermissions();
    const canEdit = hasPermission(PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT);

    const filterData = (newData) => {
        const { codigo, nombre, matricula } = searchRef.current.filters

        let filtered = [...newData]

        if (codigo !== '') filtered = filtered.filter(escribano => escribano.codigo.toLowerCase().includes(codigo.toLowerCase()))
        if (nombre !== '') filtered = filtered.filter(escribano => escribano.nombre.toLowerCase().includes(nombre.toLowerCase()))
        if (matricula !== '') filtered = filtered.filter(escribano => escribano.matricula.toLowerCase().includes(matricula.toLowerCase()))

        return filtered
    }

    const SearchEscribanos = () => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.ESCRIBANO,
            null,
            null,
            res => res.json().then(data => {
                setData(filterData(data))
                setIsLoading(false)
                setTableVisible(true)
                setEditMode(null)
                setEditItem(null)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
                setEditMode(null)
                setEditItem(null)
            },
        )
    }

    const confirmRemoveId = (id) => {
        setIsLoading(true)
        ServerRequest(
            REQUEST_METHOD.DELETE,
            null,
            true,
            APIS.URLS.ESCRIBANO,
            `/${id}`,
            null,
            res => res.json().then(() => {
                setData(prev => prev.filter(x => x.id !== id))
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const onEditConfirm = () => {
        if (tableVisible) SearchEscribanos()
        else {
            setEditMode(null)
            setEditItem(null)
        }
    }

    const onEditCancel = () => {
        setEditMode(null)
        setEditItem(null)
    }

    const avmr = {
        onAdd: () => {
            setEditMode('add')
            setEditItem({
                codigo: '',
                id: -Date.now(),
                nombre: '',
                orden: '',
                matricula: '',
            })
        },
        onView: (item) => {
            setEditMode('view')
            setEditItem(item)
        },
        onModify: (item) => {
            setEditMode('modify')
            setEditItem(item)
        },
        onRemove: (item) => {
            showMessageModal({
                title: 'Confirmación',
                message: '¿Está seguro de borrar el registro?',
                onConfirm: () => confirmRemoveId(item.id),
            })
        }
    }

    return <>
        <SectionHeading titles={[{ title: 'Escribanos' }, { title: 'Escribanos' }]}
                        onAddClick={canEdit ? avmr.onAdd : null} tableVisible={tableVisible} />

        <section className='section-accordion'>
            <WrapperAdvancedSearch
                ref={searchRef}
                filters={[
                    { title: 'Código', field: 'codigo', type: 'string', size: 1 },
                    { title: 'Nombre', field: 'nombre', type: 'string', size: 3 },
                    { title: 'Matrícula', field: 'matricula', type: 'string', size: 1}
                ]}
                onSearch={SearchEscribanos}
            />

            {tableVisible && (
                <TableCustom
                    className={'TableCustomBase m-top-20'}
                    data={data}
                    avmr={avmr}
                    editCode={PERMISSIONS.LISTAS_INGRESOS_PUBLICOS_EDIT}
                    messageEmpty="No se encontraron resultados"
                    columns={[
                        { Header: 'Código', accessor: 'codigo', width: '20%', },
                        { Header: 'Nombre', accessor: 'nombre', width: '20%', },
                        { Header: 'Matrícula', accessor: 'matricula', width: '20%', },
                    ]}
                />
            )}

            {editItem && (
                <EscribanoModal
                    escribano={editItem}
                    editMode={editMode}
                    onConfirm={onEditConfirm}
                    onCancel={onEditCancel}
                />
            )}
        </section>
    </>
}

export default EscribanosView
